import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import auth from '../../../service/Auth';
import { experiments_view } from '../../../service/apis';
import AuthErrorDialog from "../components/AuthError";

import SearchFrame from "./components/SearchFrame";
import FootFrame from "./components/FootFrame";
import Paper from '@mui/material/Paper';
import VirtualizedTable from "../components/VirtualizedTable";

const config = window.config;

const dataHeader = [
    { label: "Local Experiment ID", dataKey: "LocalExperimentID", width: 225}, 
    { label: "Participant ID", dataKey: "Participant_ID", width: 225},
    { label: "Owner", dataKey: "Owner", width: 225},
    { label: "Experiment ID", dataKey: "ExperimentID", width: 225},
    { label: "Load Date", dataKey: "LOADDATE", width: 225}
];


const SelectExperiments =()=>{

    const [field, setField] = useState(dataHeader[0].dataKey);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [filter, setFilter] = useState(false);
    const [complete, setComplete] = useState(false);
    const [deleteExperiment, setDeleteExperiment] = useState(false);
    const [experimentSelected, setExperimentsSelected] = useState([]);
    const [authError, setAuthError] = useState("");

    const handleRadioChange = (event) => {
        setField(event.target.value);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    }

    const searchButtonHandler = (event) => {
        setFilter(true);
    }

    const completeSubmissionHandler = (event) => {
        setComplete(true);
    }

    const deleteExperimentsHandler = (event) => {
        if (experimentSelected.length > 0) {
            setDeleteExperiment(true); 
        }
    }

    let bodyPost = { 
        "page" : 1, "pageSize" : 1,
        "fields" : ["LocalExperimentID", "Participant_ID", "Owner", "ExperimentID","LOADDATE"],
        "filtered":[{"id":"Owner","value":auth.getUserGroups()}, {"id":"file_submission_close","value":["false"]}]
    }

    useEffect(() => {    
        if (auth.tokenExpired()){  
            setAuthError("Logging session timeout. Please log again");
        } else {
            // 1. Function to get total items and all data 
            const fetchData = async () => {
                // 1. Get total items file submission close
                const closedItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                .then((response) => { return response.json()})
                .then((dataApi) => {
                    return dataApi["_meta"]["total_items"];
                });
                // 2. Get No Experiments data
                if (closedItems > 0) {
                    bodyPost["pageSize"] = closedItems;
                    const dataItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                    .then((response) => { return response.json()})
                    .then((dataApi) => {
                        return dataApi["items"].map((item, index) => { item["id"] = index;  return item;});
                    });
                    setData(dataItems);              
                }                
                setLoad(true);
            }
            // 3. Call function
            fetchData().catch(console.error);
        }
    }, [])

    useEffect(() => {        
        // 1. Function to get total items and all data 
        const fetchData = async () => {
            if (filter) {
                // 1.1. Get total items
                const queryItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                .then((response) => { return response.json()})
                .then((dataApi) => {
                    return dataApi["_meta"]["total_items"];
                });
                // 1.2. Get No Experiments data
                bodyPost["pageSize"] = queryItems;
                if (search != "")
                {
                    bodyPost["filtered"].push({"id":field, "value":[search]});
                }
                else{
                    bodyPost["filtered"] = [{"id":"Owner","value":auth.getUserGroups()}];
                }
                const dataItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                .then((response) => { return response.json()})
                .then((dataApi) => {
                    return dataApi["items"].map((item, index) => { item["id"] = index;  return item;});
                });
                setData(dataItems);
                setFilter(false);
            }
        }
        // 2. Call function
        fetchData().catch(console.error);
    }, [filter])

    /* OpenID session token error*/
    if (authError !== "" ) {
        return (
            <AuthErrorDialog errors={authError} open={true}/>
        );
    }

    /*Go to files submission*/
    if (complete) {
        const dataSelected = data.filter(row => experimentSelected.includes(row.id));
        return <Redirect to={{pathname:'/submitfiles',defaultContents:dataSelected}}/>;
    }
   
    // Got to delete action
    if (deleteExperiment) {
        let actions = [{"name":"Delete Experiment Submission Open", "value":"deleteExperiment"}];
        const selected = data.filter(row => experimentSelected.includes(row.id));
        let expActions = Object.assign({}, ...selected.map(
            (item) => ({
                [item.ExperimentID]: {
                    "LocalExperimentID": item.LocalExperimentID,
                    "file_submission_close": false, 
                    "postembargo": false, "projects": "empty", "sharedGroups": "empty" }
                })
            )
        );
        return <Redirect to={{pathname:'/actionpage',action: "deleteExperiment",actions: actions,
                              experiments: expActions, next:'/experiments'}} />;
    }

    
    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> Experiments submission not completed </Typography>
            { load ?   
                <Grid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
                    <Grid item>
                        <SearchFrame header={dataHeader} 
                                fieldSelected={field} handleRadioChange={handleRadioChange}
                                search={search} handleSearchChange={handleSearchChange}
                                searchButtonHandler={searchButtonHandler}/> 
                    </Grid>
                    <Paper component={Grid} 
                           container 
                           item
                           elevation={1}
                           style={{ height: 400, width: 900 }}
                           sx={{m:2}}
                           spacing={2}>
                                <VirtualizedTable columns={[{dataKey:"checkbox"},...dataHeader]} 
                                                  rowCount={data.length}
                                                  rowGetter={({ index }) => data[index]}
                                                  rows={data}
                                                  checkedRows={experimentSelected} 
                                                  setCheckedRows={setExperimentsSelected} /> 
                       
                    </Paper>
                    <Grid item >
                        <FootFrame selectedExperiments={experimentSelected.length} totalExperiments={data.length}
                                completeSubmissionHandler={completeSubmissionHandler}
                                deleteExperimentsHandler={deleteExperimentsHandler} />
                    </Grid>
                </Grid>                
              : 
                <Grid container justifyContent="center" alignItems="center" direction="row" spacing={2}>
                    <Grid item>
                        <CircularProgress />
                    </Grid>               
                </Grid>
            }
        </div>                 
    )
} 
 
export default SelectExperiments;
